export const CONTACT_SUPPORT_TOPICS = [
  {
    label: 'Contact support',
    value: 'Contact support',
  },
  {
    label: 'Ask a question',
    value: 'Ask a question',
  },
  {
    label: 'Give feedback',
    value: 'Give feedback',
  },
  {
    label: 'Share an idea',
    value: 'Share an idea',
  },
  {
    label: 'Report a bug',
    value: 'Report a bug',
  },
];
